<button class="btn-text-link download" (click)="export()" data-cy="excel-download-button">
    <span class="iwp-icon-gen_download"></span>
    Download Excel
</button>
